export enum STORAGE {
  LOCAL_STORAGE = "localStorage",
  SESSION_STORAGE = "sessionStorage",
}
